export default "__VITE_ASSET__CugJTaot__"